import classNames from 'classnames';
import BorrowBanner from '@/shared/assets/svg/borrow-card.svg';
import { BannerCard } from '@/shared/components/BannerCard';
import Button from '@/shared/components/flip-ui-kit/Button';
import { isBlockExplorerApp } from '@/shared/featureFlags';
import { useLendingPools } from '@/shared/hooks/useLendingPools';
import ArrowIcon from '@/shared/icons/flip-ui-kit/large/Arrow';
import { formatUsdValue } from '@/shared/utils/numbers';

const BorrowBannerCard = ({ onClick }: { onClick: () => void }) => {
  const { isLoading, stablecoinsTotalAvailableAmountUsd } = useLendingPools();

  return (
    <BannerCard
      className="h-[168px]"
      header="Borrow against your assets"
      headerClassName="font-aeonikMedium text-white"
      body={
        <div className="flex gap-x-2 font-aeonikMedium text-[32px] text-white">
          <span className={classNames(isBlockExplorerApp && 'hidden 2xl:block')}>Access</span>
          <span className={classNames(isBlockExplorerApp && 'capitalize 2xl:normal-case')}>up</span>
          to
          <span className="text-cf-blue-2">
            {formatUsdValue(stablecoinsTotalAvailableAmountUsd)}
          </span>
          in stables
        </div>
      }
      isBodyLoading={isLoading}
      action={
        <Button
          type="primary-standard"
          size="medium"
          iconPos="right"
          icon={<ArrowIcon direction="right" />}
        >
          Borrow
        </Button>
      }
      bannerImg={<BorrowBanner />}
      onClick={onClick}
    />
  );
};

export default BorrowBannerCard;
